import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import ViewSlots from './ViewSlots'
import './MenteeProfileStyle.css'
import '../../Mentor/MnMyProfile/MnMyProfileStyle.css'
import { useDispatch, useSelector } from 'react-redux';
import { bookMentorSlot, clearSlots, clearState, getMentorAvailableDates, getMentorSlotsByDate, getParticularUser, menteeData } from '../../../reducer/menteeSlice';
import moment from 'moment';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import SessionDetailpopup from '../../../components/Popups/SessionDetailpopup/SessionDetailpopup';
import ReSchedulePopup from '../../../components/Popups/ReSchedulePopup/ReSchedulePopup';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import Skeleton from 'react-loading-skeleton';

function MentorProfile() {

    //Filter templates
    const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const months = [moment().month(), moment().add(1,"months").month(), moment().add(2,"months").month(), moment().add(3,"months").month(), moment().add(4,"months").month(), moment().add(5,"months").month(), moment().add(6,"months").month(), moment().add(7,"months").month(), moment().add(8,"months").month(), moment().add(9,"months").month(), moment().add(10,"months").month(), moment().add(11,"months").month()];

    const [selectedMonth, setSelectedMonth] = useState("");
    const [TabSlotProfile, setTabSlotProfile] = useState(1)
    const [slotPopupToggler, setSlotPopupToggler] = useState(false);
    const [congratsPopup, setCongratsPopup] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedSlot, setSelectedSlot] = useState({
        id: "",
        time: ""
    });
    const [agenda, setAgenda] = useState("");
    const [agendaError, setAgendaError] = useState("");

    //Toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

    const { isFetching, isSlotsFetching, isSlotDatesFetching, isBookingCall, isSuccess, isError, errorMessage, particularUser, mentorSlotDates, mentorSlots } = useSelector(menteeData);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userId } = useParams();

    //Get Months difference
    const getDiff = (param) => {
        const today = moment().month();
        const date = moment(param).month();
        return today - date;
    }
    
    const handleSelectSlot = (id, time) => {
        setSelectedSlot({
            id,
            time
        });
    };

    const handleScheduleCall = () => {
        if(!agenda) setAgendaError("Please specify agenda of call")
        else dispatch(bookMentorSlot({slotId: selectedSlot["id"], agenda}));
    };
    
    const handleAgendaDiscard = () => {
        setAgenda("");
        setAgendaError(false);
        setSlotPopupToggler(false);
    };
    
    const handleCallConfirmed = () => {
        setCongratsPopup(false);
        navigate("/mentee/callHistoryMentees");
    };

    //Filter functions
    const handleDateFilter = (e) => {
        dispatch(clearSlots());
        const { value } = e.target;
        setSelectedMonth(value)
        const year = moment().year();
        let month = monthNames[value];
        const date =  moment(`${year}-${month}-01`).format("YYYY-MM-DD");
        if(monthNames[moment().month()] === month) dispatch(getMentorAvailableDates({userId}))
        else dispatch(getMentorAvailableDates({userId, date}));
    };

    useEffect(() => {
        dispatch(getParticularUser({user: "mentor", userId}))
    },[])

    useEffect(() => {
        if(selectedDate) {
            dispatch(getMentorSlotsByDate({date: selectedDate, userId}));
        }
    },[selectedDate]);
    
    useEffect(() => {
        dispatch(clearSlots());
        setSelectedMonth(months[0])
        setSelectedSlot({
            id: "",
            time: ""
        })
        if(TabSlotProfile === 2) dispatch(getMentorAvailableDates({userId}));
    },[TabSlotProfile]);

    useEffect(() => {
        dispatch(clearSlots());
        if(isSuccess) {
            setSlotPopupToggler(false); 
            setCongratsPopup(true);
            setIsShowSuccess(true);
            setSuccessMessage("Success!");
            setTimeout(() => {
                navigate("/mentee/call-records");
            },1000);
            dispatch(clearState());
        }
    },[isSuccess]);
    
    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError]);

    return (
        <>
        {isBookingCall && <PageLoader />}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />
        <SessionDetailpopup isActive={slotPopupToggler} setIsActive={setSlotPopupToggler} handleDiscard={handleAgendaDiscard} handleClose={handleAgendaDiscard} selectedDate={selectedDate} selectedSlot={selectedSlot} mentorData={particularUser} agenda={agenda} errorAgenda={agendaError} handleAgendaChange={(e) => {setAgenda(e.target.value);setAgendaError(false);}} onScheduleCall={handleScheduleCall} />
        <section >
            <div className="DashboardWrapper">
                <div className='pathlinkwrapper flex gap-10'>
                    <img src='assets/img/usericons.png' alt="" />
                    <p className='text2' onClick={()=> navigate('/mentee/all-mentor')}>All Mentors</p>
                    <img src="/assets/img/arrowright.png" alt="" />
                    <p className='text2'>Mentor Profile</p>
                </div>

                <div className="headingprofilewrap mt-30">
                    <h2 className='heading-2'>{isFetching ? <Skeleton width={"210px"} height={"20px"} /> : 'Profile Overview'}</h2>
                    <p className='text3 mt-5'>{isFetching ? <Skeleton width={"200px"} /> : `Joined ${getDiff(particularUser?.createdAt)} month${getDiff(particularUser?.createdAt) > 1 ? 's' : ''} ago`}</p>
                </div>

                <div className="flex-col Allcardboxwrapper mt-30">
                    <div className="profilewrapper w-100 ">
                        <div className="Adprofiledatawrapper flex-start">
                            {isFetching ? <Skeleton width={"150px"} height={"150px"} circle /> : <div className='Imageboxall'>
                                <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                            </div>}
                            <div className="AdProfileDetailsarea">
                                <div className="headingwrap">
                                    <div className="headingorg flex gap-10">
                                        <h2 className='heading-2'>{isFetching ? <Skeleton width={"200px"} /> : particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                        {particularUser?.linkedin && <a href={particularUser?.linkedin.slice(0,4) === "http" ? particularUser?.linkedin : "https://" + particularUser?.linkedin} className='linkedintext' target='_blank' rel='noreferrer'>
                                            <span className='flex gap-2'>
                                                {"Linkedin"}
                                                <img src="/assets/img/send.png" alt="" />
                                            </span>
                                        </a>}
                                    </div>
                                    <div className="AdPsnlDetailsMentors mt-10">
                                        {isFetching ? <Skeleton width={"250px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/usermentor.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.profession?.designation ? particularUser?.profession?.designation: "---"}, {particularUser?.profession?.company ? particularUser?.profession?.company: "---"}</p>
                                        </div>}
                                        {isFetching ? <Skeleton width={"200px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/emailprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                        </div>}
                                        {isFetching ? <Skeleton width={"100px"} /> : <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/callprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.mobileNumber ? particularUser?.mobileNumber : "---"}</p>
                                        </div>}
                                    </div>
                                </div>
                                <div className="AdCardsProfilWrapper flex gap-10 mt-40">
                                    {isFetching ?
                                    <div className={`CardContactWrapper`}>
                                    <span className='Adicontoolsicons flex-center'>
                                        <Skeleton width={"50px"} height={"50px"} circle />
                                    </span>
                                    <div className="contentareacontact">
                                        <span><Skeleton width={"50px"}/></span>
                                        <p className='mt-5 text2'><Skeleton width={"140px"} /></p>
                                    </div>
                                </div>
                                : <ProfileCard number={particularUser?.noOfCalls ?? 0} text={'Delivered Solutions'} img={"/assets/img/yellowcall.png"} />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="AdMenusTabWrapper w-100 mt-40">
                        <ul className='flex gap-30 items-center'>
                            <li onClick={() => setTabSlotProfile(1)} className={TabSlotProfile === 1 && 'active'}>Profile Details</li>
                            <li onClick={() => setTabSlotProfile(2)} className={TabSlotProfile === 2 && 'active'}>View Slots</li>
                        </ul>
                    </div>

                </div>

            </div>

            <Profiledetails isActiveTab={TabSlotProfile === 1 && 'active'} data={particularUser} isFetching={isFetching} />
            <ViewSlots isActiveTab={TabSlotProfile === 2 && 'active'} selectedMonth={selectedMonth} isSlotDatesFetching={isSlotDatesFetching} isSlotsFetching={isSlotsFetching} mentorData={particularUser} slotDates={mentorSlotDates} mentorSlots={mentorSlots} selectedDate={selectedDate} setSelectedDate={setSelectedDate} setSlotPopupToggler={setSlotPopupToggler} selectedSlot={selectedSlot} onSelectTime={handleSelectSlot} monthNames={monthNames} months={months} handleDateFilter={handleDateFilter} />
        </section>
        </>
    )
}

export default MentorProfile